import React, { useContext } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { CartContext } from "../Context/CartContext";

function Cart() {
  const { cartItems, removeFromCart } = useContext(CartContext);

  return (
    <>
      <Header />

      <div className="container sp">
        <h2 className="text-center mb-4">My Cart</h2>

        <div className="row">
          {cartItems.length === 0 ? (
            <h4 className="text-center">Your cart is empty</h4>
          ) : (
            cartItems.map((item, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div className="shop3-item mt-40 position-relative">

                  <button className="wishlist-btn" onClick={() => removeFromCart(item.id)}>
                    <i className="fa-solid fa-xmark"></i>
                  </button>

                  <div className="image-area">
                    <div className="image">
                      <img src={item.img} alt={item.title} />
                    </div>
                  </div>

                  <div className="content">
                    <h6>{item.title}</h6>
                    <h3>{item.price}</h3>

                    <button className="theme-btn7 add-cart-btn">
                      Checkout
                    </button>
                  </div>

                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Cart;
